var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderShipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 80,
    viewBox: "0 0 179 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251102",
    d: "M88 79L178 79",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251103",
    d: "M17 79L48.9392 79",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250585",
    d: "M127.832 21.25H111.994V48.8798V61.6005H142.716C144.476 61.6005 145.858 60.092 145.704 58.3384L144.787 47.8732C144.651 46.3253 143.92 44.8904 142.748 43.8705L140.33 41.7672L130.494 22.8651C129.977 21.8726 128.951 21.25 127.832 21.25Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250586",
    d: "M132.992 48.6602H138.368",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250584",
    d: "M111.994 46.7132V21.2498V4C111.994 2.34315 110.651 1 108.994 1H45C43.3431 1 42 2.34315 42 4V21.2498V46.7132M111.994 46.7132V61.6003H45C43.3431 61.6003 42 60.2572 42 58.6003V46.7132M111.994 46.7132H42",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.8049 78.9891C70.1023 78.9891 75.2074 73.7554 75.2074 67.2992C75.2074 60.8431 70.1023 55.6094 63.8049 55.6094C57.5074 55.6094 52.4023 60.8431 52.4023 67.2992C52.4023 73.7554 57.5074 78.9891 63.8049 78.9891Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M123.1 78.9891C129.397 78.9891 134.502 73.7554 134.502 67.2992C134.502 60.8431 129.397 55.6094 123.1 55.6094C116.802 55.6094 111.697 60.8431 111.697 67.2992C111.697 73.7554 116.802 78.9891 123.1 78.9891Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251106",
    d: "M11.5 11H34.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251107",
    d: "M0 25H30",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderShipped);
export default __webpack_public_path__ + "static/media/orderShipped.c39809fb492ee93d485ae7fbcfd491b1.svg";
export { ForwardRef as ReactComponent };